var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoneYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 14.9972C13.5735 17.5675 16.5554 20.029 17.7333 18.8513C19.4179 17.167 20.4579 15.6975 24.1773 18.6868C27.8941 21.6735 25.0395 23.6655 23.4053 25.2968C21.5191 27.1827 14.4914 25.3976 7.54339 18.4534C0.598003 11.5066 -1.18212 4.48017 0.704121 2.59426C2.33833 0.960336 4.32273 -1.89373 7.30993 1.82239C10.2998 5.53851 8.83006 6.57828 7.1428 8.26525C5.9702 9.44561 8.42947 12.4243 11.0002 14.9972Z",
    fill: "#FCC800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneYellow);
export default __webpack_public_path__ + "static/media/icon_phone_yellow.3dd11692003b172955b566c9a4cdfac8.svg";
export { ForwardRef as ReactComponent };